import { z } from 'zod'
import { GeoJSONGeometrySchema } from '@/features/subgeo/types'

export const ViewOnlySubGeoSchema = z.object({
	id: z.string(),
	geoMappingGeoId: z.string(),
	geoCode: z.string(),
	clientSubGeoId: z.string(),
	name: z.string(),
	geometry: GeoJSONGeometrySchema,
	type: z.literal('view_only'),
	geoMappingFileId: z.string(),
	createdAt: z.string(),
	updatedAt: z.string()
})

export type ViewOnlySubGeo = z.infer<typeof ViewOnlySubGeoSchema>
